import workflowRoles from "./workflowRoles";
import regions from "./regions";
import documentReviewReviewers from "./documentReviewReviewers";
import config from "../../conf/config";
import assessmentDecisionReviewers from "./assessmentDecisionReviewers";

const workflowRoleSettingService = [
    {
        matcher: 'workflowRoles',
        reply: config => {
            return [200, workflowRoles];
        }
    },
    {
        matcher: /workflowRoles\/(.*)/,
        reply: config => {
            const id = /workflowRoles\/(.*)/.exec(config.url)[1];
            const data = workflowRoles.find(item => item.uuid === id);
            return [200, data];
        }
    },
    {
        matcher: 'regions',
        reply: config => {
            return [200, regions];
        }
    },
    {
        matcher: /regions\/(.*)/,
        reply: config => {
            const id = /regions\/(.*)/.exec(config.url)[1];
            const data = regions.find(item => item.uuid === id);
            return [200, data];
        }
    },
    {
        matcher: 'documentReviewReviewers',
        reply: config => {
            return [200, documentReviewReviewers];
        }
    },
    {
        matcher: /documentReviewReviewers\/(.*)/,
        reply: config => {
            const id = /documentReviewReviewers\/(.*)/.exec(config.url)[1];
            const data = documentReviewReviewers.find(item => item.uuid === id);
            return [200, data];
        }
    },
    {
        matcher: 'assessmentDecisionReviewers',
        reply: config => {
            return [200, assessmentDecisionReviewers];
        }
    }
]

export default workflowRoleSettingService;